import { Close as CloseIcon, TaskRounded } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Avatar, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { resetInspectionSelectedFilters, setInspectionSelectedFilters } from 'app/actions/checklist';
import { Scrollbar } from 'app/components';
import { ChecklistInspectionFilterForm } from 'app/pages/Checklist';
import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const ChecklistInspectionFilterDialog = (props) => {
  const formRef = useRef();
  const dispatch = useDispatch();
  const { open, onClose } = props;
  const { inspectionSelectedFilters } = useSelector((state) => state.checklist);

  const handleFormClick = () => {
    formRef.current?.handleFormSubmit();
    onClose();
  };

  const handleResetClick = () => {
    dispatch(resetInspectionSelectedFilters());
  };

  const handleFormSubmit = (params) => dispatch(setInspectionSelectedFilters(params));

  return (
    <Dialog
      maxWidth='md'
      fullWidth
      open={open}
      onClose={onClose}
      sx={(theme) => ({
        width: '100%',
        height: '100%',
        '.MuiDialog-paper': {
          minWidth: '540px',
        },
        '.MuiDialogTitle-root': {
          display: 'flex',
          padding: theme.spacing(2),
          alignItems: 'center',
        },
        '.MuiDialogTitle-root .MuiTypography-root': {
          marginLeft: theme.spacing(1.5),
        },
        '.MuiDialogTitle-root .MuiButtonBase-root': {
          marginLeft: 'auto',
        },
        '.MuiDialogContent-root': {
          padding: theme.spacing(0),
        },
        '.MuiDialogContent-root .simplebar-container': {
          padding: theme.spacing(0, 2),
        },
        '.MuiDialogActions-root': {
          padding: theme.spacing(2),
          justifyContent: 'flex-end',
        },
        '.MuiAvatar-circular': {
          bgcolor: alpha(theme.palette.primary.main, 0.12),
          svg: {
            width: '16px',
            height: '16px',
          },
          path: {
            fill: theme.palette.primary.main,
          },
        },
        '.MuiAlert-root': {
          marginTop: theme.spacing(1),
          marginBottom: theme.spacing(2),
          borderRadius: theme.shape.borderRadius,
        },
      })}>
      <DialogTitle>
        <Avatar>
          <TaskRounded fontSize='small' />
        </Avatar>
        <Typography component='p'>Фильтры по осмотрам</Typography>
        <IconButton color='default' onClick={onClose}>
          <CloseIcon fontSize='small' />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Scrollbar>
          <ChecklistInspectionFilterForm ref={formRef} defaultValues={inspectionSelectedFilters} onSubmit={handleFormSubmit} />
        </Scrollbar>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleResetClick} disableElevation>
          Сбросить Фильтры
        </Button>
        <LoadingButton variant='contained' onClick={handleFormClick} disableElevation>
          Применить
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default ChecklistInspectionFilterDialog;
